import React from 'react';
import { IconProps } from './types';

const ReceiveRequestIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" rx="4" fill="#F3EAFD" />
      <mask id="mask0_392_12978" maskUnits="userSpaceOnUse" x="4" y="4" width="16" height="16">
        <rect x="4" y="4" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g>
        <path
          d="M7.13224 17.3337C6.92488 17.3337 6.75107 17.2635 6.6108 17.1233C6.47053 16.983 6.40039 16.8092 6.40039 16.6018V10.747C6.40039 10.5397 6.47053 10.3659 6.6108 10.2256C6.75107 10.0853 6.92488 10.0152 7.13224 10.0152C7.33959 10.0152 7.51341 10.0853 7.65368 10.2256C7.79395 10.3659 7.86408 10.5397 7.86408 10.747V14.8454L15.8412 6.86825C15.9754 6.73408 16.1462 6.66699 16.3535 6.66699C16.5609 6.66699 16.7316 6.73408 16.8658 6.86825C17 7.00242 17.0671 7.17319 17.0671 7.38054C17.0671 7.5879 17 7.75866 16.8658 7.89284L8.88867 15.87H12.987C13.1944 15.87 13.3682 15.9401 13.5085 16.0804C13.6487 16.2206 13.7189 16.3945 13.7189 16.6018C13.7189 16.8092 13.6487 16.983 13.5085 17.1233C13.3682 17.2635 13.1944 17.3337 12.987 17.3337H7.13224Z"
          fill="#8B2CE9"
        />
      </g>
    </svg>
  );
};
export default ReceiveRequestIcon;
